import React from 'react';

import TracklogMapControls from 'ff/debrief/components/map/TracklogMapControls';
import FlightDetails from 'ff/debrief/components/details';
import ErrorBar from 'ff/debrief/components/ErrorBar';
import SharedSidebar from 'ff/debrief/components/sidebar/SharedSidebar';
import MapAreaGrid from 'ff/debrief/layouts/MapAreaGrid';
import { LinkToSharedDebrief, LinkToShared } from 'ff/debrief/router';
import { useRouteContext } from 'ff/debrief/hooks';

export const pathString = '/shared/:shareId?';

const SharedRoute = () => {
    useRouteContext({
        returnLink: LinkToShared,
        debriefLink: LinkToSharedDebrief,
        page: 'SharedWithMeView',
    });

    return (
        <MapAreaGrid>
            <TracklogMapControls />
            <SharedSidebar />
            <FlightDetails />
            <ErrorBar />
        </MapAreaGrid>
    );
};

export default SharedRoute;
